import { apiRequest } from "../../utils/apiUtils";

export const marketApi = {
  getMarket: () =>
    apiRequest<any>("get", "/admin/second-hand-market?order=4", {
      fullResponse: true,
    }),
  getSecondHandMarketNoticeList: () =>
    apiRequest<any>("get", "/admin/second-hand-market-notice", {
      fullResponse: true,
    }),
};
